export default __webpack_public_path__ + "969f009c55c923ba6575bb1eae7fbf76.png";